'use strict';

var chunkGWPDT7BR_js = require('../chunk-GWPDT7BR.js');
require('../chunk-U3QCK4FI.js');
var chunkHUKGHOBJ_js = require('../chunk-HUKGHOBJ.js');
require('../chunk-S7FZ7BAB.js');
require('../chunk-M632V57T.js');
var l = require('react');
var i = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var l__default = /*#__PURE__*/_interopDefault(l);
var i__default = /*#__PURE__*/_interopDefault(i);

var F=i__default.default.table`
  border-collapse: collapse;
  width: 100%;
  ${({$isExpandable:e})=>e&&"margin-bottom: 20px;"}
`,P=i__default.default.thead``,H=i__default.default.tbody`
  ${({$isStriped:e,$stripColor:o})=>e&&`
    & > tr:nth-child(odd) {
      background-color: ${o};
    }
  `}
`,_=i__default.default.tr`
  ${({$expanded:e,$visibleRowCount:o,$index:d,$isExpandable:s})=>`
    ${s&&!e&&o<d+1&&`
      display: none;
    `}
  `}
`,C=i__default.default.th`
  padding: ${({$padding:e})=>e};
  color: ${({$color:e})=>e};
  size: ${({$size:e})=>e};
  font-weight: ${({$fontWeight:e})=>e};
  line-height: ${({$lineHeight:e})=>e};
  text-align: left;
`,W=i__default.default.td`
  padding: ${({$padding:e})=>e};
  color: ${({$color:e})=>e};
  size: ${({$size:e})=>e};
  font-weight: ${({$fontWeight:e})=>e};
  line-height: ${({$lineHeight:e})=>e};
  text-align: left;
`,A=i__default.default.a`
  color: ${({$color:e})=>e};
  text-decoration: none
`,D=({isExpandable:e=!1,heading:o,data:d,onViewChange:s,isStriped:b,visibleRowCount:p,expandedText:c,collapsedText:S,color:$="",stripColor:T="#FFFFFF0A",expandVariant:x="brand",onRowClick:y})=>{let[g,u]=l.useState(!1),{tokens:n}=chunkHUKGHOBJ_js.b(),k=()=>{let t=!g;u(t),typeof s=="function"&&s(t);},m=t=>{typeof y=="function"&&y(t);};return !!(d||[]).length&&l__default.default.createElement(l__default.default.Fragment,null,l__default.default.createElement(F,{$isExpandable:e},l__default.default.createElement(P,null,l__default.default.createElement(_,{$isExpandable:!1,$visibleRowCount:p||d.length,$expanded:!1,$index:0},o.map((t,r)=>l__default.default.createElement(C,{key:`dls-thead-${r}`,$color:$||n.text_default_text_inverse,$padding:n.spacing_16,$size:n.font_size_lg,$fontWeight:n.font_weight_semibold,$lineHeight:n.font_line_height_lg},t.label)))),l__default.default.createElement(H,{$isStriped:b,$stripColor:T},d.map((t,r)=>l__default.default.createElement(_,{key:`dls-tr-${r}`,$isExpandable:e,$visibleRowCount:p||d.length,$expanded:g,$index:r,onClick:()=>m(t)},o.map((a,v)=>l__default.default.createElement(W,{key:`dls-td-${v}`,$color:$||n.text_default_text_inverse,$padding:n.spacing_16,$size:n.font_size_lg,$fontWeight:n.font_weight_regular,$lineHeight:n.font_line_height_lg},t.isHyperLink&&t[a.hyperLinkKey]&&t.url?l__default.default.createElement(A,{$color:$||n.text_default_text_inverse,href:t.url},t[a.key]):t[a.key])))))),e&&l__default.default.createElement(chunkGWPDT7BR_js.a,{label:g?c:S,onClick:k,variant:x,preventDefaultBehaviour:!0}))};

exports.Table = D;
